import lodash from 'lodash';
window._ = lodash;
import createAuthRefreshInterceptor from 'axios-auth-refresh'

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.withCredentials = true;


const getCSRFToken = () => {
    let token = document.head.querySelector(
        'meta[name="csrf-token"]'
    );
    return token?.content
}

const token = getCSRFToken()

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token
} else {
    console.error(
        'CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token'
    )
}

const refreshCSRFToken = () => {
    return new Promise((resolve, reject) => {
        console.log('Token expired, fetching a new one')
        window.axios
            .get('/login')
            .then(({ data }) => {
                const wrapper = document.createElement('div')
                wrapper.innerHTML = data
                return wrapper
                    .querySelector('meta[name=csrf-token]')
                    ?.getAttribute('content')
            })
            .then((token) => {
                document
                    .querySelector('meta[name=csrf-token]')
                    ?.setAttribute('content', token || '')
                resolve()
            })
            .catch(() => reject())
    })
}

createAuthRefreshInterceptor(axios, refreshCSRFToken, {
    statusCodes: [419],
})

// Using a second interceptor to inject the newly fetched CSRF token to all requests
window.axios.interceptors.request.use((request) => {
    request.headers['X-CSRF-TOKEN'] = getCSRFToken()
    return request
})


/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// import Pusher from 'pusher-js';
// window.Pusher = Pusher;

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: import.meta.env.VITE_PUSHER_APP_KEY,
//     cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER ?? 'mt1',
//     wsHost: import.meta.env.VITE_PUSHER_HOST ? import.meta.env.VITE_PUSHER_HOST : `ws-${import.meta.env.VITE_PUSHER_APP_CLUSTER}.pusher.com`,
//     wsPort: import.meta.env.VITE_PUSHER_PORT ?? 80,
//     wssPort: import.meta.env.VITE_PUSHER_PORT ?? 443,
//     forceTLS: (import.meta.env.VITE_PUSHER_SCHEME ?? 'https') === 'https',
//     enabledTransports: ['ws', 'wss'],
// });
